import { useNotifications } from "../lib/useNotifications";
import { FC, useMemo } from "react";
import {
  ChipsWrapper,
  NotificationsHead,
  NotificationsWrapper,
} from "./styles";

import Multiselect from "@atomaro/ui-kit/components/Multiselect/Multiselect";
import Chip from "@atomaro/ui-kit/components/Chip/Chip/Chip";
import { NotificationsList } from "./NotificationsList";
import InputDate from "@atomaro/ui-kit/components/InputDate/InputDate";
import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import { COLORS } from "shared/consts";

type NotificationsProps = {
  isModal?: boolean;
};
export const Notifications: FC<NotificationsProps> = ({ isModal = false }) => {
  const {
    hives,
    notifications,
    status,
    counters,
    onHivesChange,
    onChipClick,
    onInView,
    onReadAllClick,
    onDateChange,
  } = useNotifications();

  const hiveItems = useMemo(() => {
    return hives.map((hive) => ({ value: `№${hive.number}`, key: hive.id }));
  }, [hives]);

  return (
    <NotificationsWrapper>
      <NotificationsHead>
        <Multiselect
          items={hiveItems}
          placeholder="Номер улья"
          size="m"
          dropdownMenuStyle={{
            maxHeight: "calc(80dvh - 6rem)",
            overflowY: "auto",
          }}
          inputMode="numeric"
          useInPortal={false}
          autocomplete={{
            enabled: true,
          }}
          onChange={onHivesChange}
        />
        <InputDate useInPortal={false} isRange onChange={onDateChange} />
        <Button
          colorScheme="neutral"
          iconPrefix={
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.2244 6.79795L10.4537 3.05057C10.1777 2.87133 9.82201 2.87133 9.54598 3.05057L3.7753 6.79795L9.99984 11.0948L16.2244 6.79795ZM2.9165 7.72402V15C2.9165 15.6903 3.47615 16.25 4.1665 16.25H15.8332C16.5235 16.25 17.0832 15.6903 17.0832 15V7.72402L10.3549 12.3686C10.1412 12.5162 9.85849 12.5162 9.64477 12.3686L2.9165 7.72402ZM1.6665 7.1294C1.6665 6.84721 1.80932 6.58419 2.04598 6.4305L8.8652 2.00222C9.55526 1.55411 10.4444 1.55411 11.1345 2.00222L17.9537 6.4305C18.1904 6.58419 18.3332 6.84721 18.3332 7.1294V15C18.3332 16.3807 17.2139 17.5 15.8332 17.5H4.1665C2.78579 17.5 1.6665 16.3807 1.6665 15V7.1294Z"
                fill={COLORS.NEUTRAL.DEFAULT}
              />
            </svg>
          }
          onClick={onReadAllClick}
        />
        <ChipsWrapper>
          <Chip
            label="Не прочитанные"
            counter={counters.unreadCount}
            size="m"
            selected={status.current === "NEW"}
            onClick={() => onChipClick("NEW")}
          />
          <Chip
            label="Прочитанные"
            counter={counters.readCount}
            size="m"
            selected={status.current === "READ"}
            onClick={() => onChipClick("READ")}
          />
          <Chip
            label="Все"
            counter={counters.total}
            size="m"
            selected={!status.current}
            onClick={() => onChipClick(null)}
          />
        </ChipsWrapper>
      </NotificationsHead>
      <NotificationsList
        notifications={notifications}
        onInView={onInView}
        isModal={isModal}
      />
    </NotificationsWrapper>
  );
};
